import { render, staticRenderFns } from "./BehavioralQnrIntroGetStarted.vue?vue&type=template&id=267e98de&scoped=true&"
import script from "./BehavioralQnrIntroGetStarted.vue?vue&type=script&lang=js&"
export * from "./BehavioralQnrIntroGetStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e98de",
  null
  
)

export default component.exports